import { render, staticRenderFns } from "./selectDataCenterDialog.vue?vue&type=template&id=2246d4fa&scoped=true&"
import script from "./selectDataCenterDialog.vue?vue&type=script&lang=tsx&"
export * from "./selectDataCenterDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./selectDataCenterDialog.vue?vue&type=style&index=0&id=2246d4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246d4fa",
  null
  
)

export default component.exports